export default "__VITE_ASSET__BaWxTgub__"